import { render, staticRenderFns } from "./LandingPageWrapper.vue?vue&type=template&id=2ed9a5e8&scoped=true&"
import script from "./LandingPageWrapper.vue?vue&type=script&lang=ts&"
export * from "./LandingPageWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed9a5e8",
  null
  
)

export default component.exports